import Vue from "vue";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import { releaseDate } from "@shared/components/DeployDate/releaseDate";

const apiKey = process.env.VUE_APP_BUGSNAG_KEY;
const releaseStage = process.env.VUE_APP_RELEASE_STAGE;

if (apiKey) {
	Bugsnag.start({
		apiKey,
		releaseStage,
		appVersion: releaseDate || "development",
		plugins: [new BugsnagPluginVue()]
	});
	Bugsnag.getPlugin("vue").installVueErrorHandler(Vue);
}

export default Bugsnag;
